import React from 'react'
import parse from 'html-react-parser'
import 'Source/index.less'
import { MathJax } from 'better-react-mathjax'
import { isEmpty } from 'lodash'

type HtmlRendererProps = {
    htmlContent: string
    className?: string
    onMouseUp?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}

const HtmlRenderer: React.FC<HtmlRendererProps> = props => {
    if (isEmpty(props.htmlContent)) {
        return null
    }

    return (
        <MathJax dynamic hideUntilTypeset="every">
            <div
                className={props.className ? props.className : 'html-renderer'}
                data-testid="html-renderer-wrapper"
                onMouseUp={props.onMouseUp}
            >
                {parse(props.htmlContent)}
            </div>
        </MathJax>
    )
}
export default HtmlRenderer
